import { z } from 'zod'

export function SignInSchema() {
  return z.object({
    username: z.string().nonempty(),
    password: z.string().nonempty(),
    rememberMe: z.boolean(),
  })
}

export type SignInForm = z.infer<ReturnType<typeof SignInSchema>>
